<template>
    <TransitionFadeY>
        <a v-if="mounted" class="item-app" @click="handleClick">

            <div class="preview">
                <img class="image" :src="image" />
            </div>

            <div class="content">
                <h2 class="name" v-html="name"></h2>
                <h3 class="description" v-html="description"></h3>
            </div>

        </a>
    </TransitionFadeY>
</template>

<script>
import { TransitionFadeY } from '@generio-ai/library-legacy/components/transitions'

export default {
    name: 'ItemApp',
    components: {
        TransitionFadeY
    },
    props: {
        route: {
            type: Object,
            required: true
        },
        image: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        description: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            mounted: false
        }
    },
    methods: {
        handleClick() {
            this.$router.push({ path: this.route.path })
        }
    },
    mounted() {
        this.mounted = true
    }
}
</script>

<style scoped>
@keyframes animation {
    0% {
        opacity: 0;
        transform: translateY(75px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.item-app {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 150px;
    border-radius: 8px;
    text-decoration: none;
    background: linear-gradient(to bottom, rgb(var(--v-theme-darkbase)), rgba(var(--v-theme-darkerbase), 0.5));
    cursor: pointer;
    animation: animation 0.5s ease-out forwards;
    overflow: hidden;
    border: 2px solid rgb(var(--v-theme-lightbase));
    box-shadow: 0px 0px 15px rgba(var(--v-theme-color1), 0.2);
    transition: background-color 0.3s ease, border-color 0.3s ease;
}

.item-app .preview {
    max-width: 200px;
    height: 100%; 
    object-fit: cover;
    background-color: rgb(var(--v-theme-darkbase));
    overflow: hidden; 
    position: relative;
    border-right: 1px solid rgb(var(--v-theme-lightbase));
}

.item-app .preview .image {
    width: 100%; 
    height: 100%;
    object-fit: cover;
    object-position: center;
    background-color: white;
    image-rendering: auto;
    transition: transform 0.3s ease, color 0.3s ease;
}
    
.item-app:hover .preview .image {
    transform: scale(1.2);
    color: rgba(var(--v-theme-invert), 1.0);
}

.item-app .content {
    flex: 1; 
    padding: 10px;
    padding-left: 30px;
    padding-right: 30px;
    box-sizing: border-box;
}

.item-app .content .name {
    margin-top: 0; 
    margin-bottom: 0px; 
    font-size: 1.4rem;
    text-align: left;
    color: rgb(var(--v-theme-primary));
}

.item-app .content .description {
    margin-top: 0; 
    margin-bottom: 10px; 
    font-size: 1.2rem;
    font-weight: normal;
    text-align: left;
    color: rgb(var(--v-theme-secondary));
}

@media (hover: hover) and (pointer: fine) {
    .item-app:hover {
        border-color: rgb(var(--v-theme-color1));
        box-shadow: 0 4px 12px rgba(var(--v-theme-color1), 0.3);
    }
}

@media (max-width: 1200px) {
    .item-app .preview .image {
        font-size: 50px;
    }

    .item-app .content .name {
        font-size: 1.1rem;
    }

    .item-app .content .description {
        font-size: 1rem;
    }
}

@media (max-width: 1000px) {
    .item-app .preview {
        max-width: 180px;
    }
}

@media (max-width: 800px) {
    .item-app {
        flex-direction: column;
    }

    .item-app .preview {
        flex-shrink: 1;
        width: 100%;
        max-width: none;
        max-height: 150px;
        border-right: none;
        border-bottom: 1px solid rgb(var(--v-theme-lightbase));
    }

    .item-app .preview .image {
        font-size: 80px;
    }

    .item-app .content {
        width: 100%;
        padding-left: 10px;
        padding-right: 10px;
    }

    .item-app .content .name {
        text-align: center;
        font-size: 1rem;
    }

    .item-app .content .description {
        text-align: center;
        font-size: 0.9rem;
    }
}
</style>